import { useEffect, useState } from 'react';

import { applyTextCustomization } from './TextCustomization';

import './TextFormattingToolbar.css';

export default function TextFormattingToolbar({ editableRef, previewMode, enabled }) {
  const [isTextSelected, setIsTextSelected] = useState(false);

  useEffect(() => {
    if (previewMode) return;
    const onSelectChange = () => {
      const sel = window.getSelection();
      if (!sel.rangeCount || !editableRef.current) {
        setIsTextSelected(false);
        return;
      }
      const range = sel.getRangeAt(0);
      if (editableRef.current.contains(range.startContainer) && sel.toString().length > 0) {
        setIsTextSelected(true);
      } else {
        setIsTextSelected(false);
      }
    };
    document.addEventListener('selectionchange', onSelectChange);
    return () => document.removeEventListener('selectionchange', onSelectChange);
  }, [previewMode, editableRef]);

  if (!enabled || !isTextSelected) return null;

  return (
    <div className="add-post__button-container">
      <button
        className="add-post__button"
        onMouseDown={e => e.preventDefault()}
        onClick={() => applyTextCustomization(editableRef, 'h1')}
      >
        H1
      </button>
      <button
        className="add-post__button"
        onMouseDown={e => e.preventDefault()}
        onClick={() => applyTextCustomization(editableRef, 'h2')}
      >
        H2
      </button>
      <button
        className="add-post__button"
        onMouseDown={e => e.preventDefault()}
        onClick={() => applyTextCustomization(editableRef, 'em')}
      >
        Italic
      </button>
      <button
        className="add-post__button"
        onMouseDown={e => e.preventDefault()}
        onClick={() => applyTextCustomization(editableRef, 'strong')}
      >
        Bold
      </button>
      <button
        className="add-post__button"
        onMouseDown={e => e.preventDefault()}
        onClick={() => applyTextCustomization(editableRef, 'quote-block')}
      >
        Quote
      </button>
    </div>
  );
}
